import React, { Component } from 'react';
import { Glyphicon, Grid, Row, Col, Clearfix } from 'react-bootstrap';

import './NavDrawer.css';

import avatarBoy from '../../../Assets/avatar-child-boy.png';
import avatarGirl from '../../../Assets/avatar-child-girl.png';
// import spriteNav from '../../../Assets/sprite-nav.png';



class NavDrawer extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }


    // Lifecycle Methods

    render() {
        const {props, state} = this;

        const rootStyle = {
            backgroundColor: 'transparent'
        };

        const navStyle = {
            transform: 'translateX(100%)'
        };

        if(props.show) {
            rootStyle.backgroundColor = 'rgba(0,0,0,0.6)';
            navStyle.transform = 'translateX(0)';
        }


        return (
        <div className="hsg-nd-root-container" style={rootStyle}>

            <div className="hsg-nd-nav-layout" style={navStyle}>
                
                <div style={{marginTop: 10}}>
                <Grid>

                    {/* User Name and Email */}
                    <Row className="show-grid" >
                    <Col xs={12}>
                        <p className="hsg-nd-name-text">{props.orgName || ''}</p>
                        <p className="hsg-nd-email-text">{props.emailId || ''}</p>
                    </Col>
                    </Row>


                    {/* Child Selection */}
                    <Row className="show-grid"
                    style={{padding: '0 10px'}}>
                        
                        {this.renderChildList()}

                    </Row>


                    {/* Talk to healthsetgo expert Button */}
                    <Row className="show-grid">
                    <Col xs={12}>

                        <div className="hsg-nd-button"
                        onClick={() => { this.onClickAction(this.props.onClickTalkToExpert) }}>
                            TALK TO A HEALTHSETGO EXPERT
                        </div>

                    </Col>
                    </Row>


                    {/* Section Buttons List */}
                    <Row className="show-grid" style={{marginTop: 20}}>
                    
                        {this.renderSectionList()}

                    </Row>


                    {/* Action Buttons List */}
                    <Row className="show-grid" style={{marginTop: 20}}>
                    
                        {this.renderActionList()}

                    </Row>

                </Grid>
                </div>


                <div className="hsg-nd-close-button"
                onClick={props.onClickClose}>
                    <Glyphicon glyph="remove" style={{fontSize: 25, color: 'white'}} />
                </div>

            </div>

        </div>
        );
    }


    // Rendering Methods

    renderChildList() {
        const list = [];
        const len = this.props.childList.length;

        this.props.childList.forEach((item, pos) => {
            list.push(
                <Col key={pos} xs={4} style={{padding: 0} }>
                <div className="hsg-nd-child-item"
                style={{background: pos == this.props.selectedChild ? 'rgba(255,255,255,0.2)' : 'transparent', }}
                onClick={() => {this.onClickChild(pos)}}>

                    <img
                        src={(Boolean(item.gender) && item.gender === 'F') ? avatarGirl : avatarBoy}
                        className="hsg-nd-child-item-image" />

                    <p className="hsg-nd-child-name">{this.formatName(item.name)}</p>

                </div>
                </Col>);

            if((pos + 1) % 3 == 0) list.push(<Clearfix key={len + pos} visibleXsBlock />);
        });

        return list;
    }


    renderSectionList() {
        return this.props.sectionList.map((item, pos) => 
            <Col key={pos} xs={12} style={{padding: 0}}>
            <div className="hsg-nd-section-button"
            style={{backgroundColor: item.selected ? 'rgba(255,255,255,0.2)' : 'transparent'}}
            onClick={() => this.onClickSection(item.onClick)}>

                <Glyphicon
                    glyph={item.icon}
                    style={{fontSize: 15,
                        color: item.selected ? 'white' : '#5794B3',
                        margin: '0 20px 0 10px'}} />

                <span style={{color: item.selected ? 'white' : '#bbbbbb'}}>{item.text}</span>

            </div>
            </Col>
        );
    }


    renderActionList() {
        return this.props.linkList.map((item, pos) =>
            <Col key={pos} xs={12} style={{padding: 0}}>
            <div
            style={{padding: 10, cursor: 'pointer'}}
            onClick={() => this.onClickAction(item.onClick)}>
                <i className={item.icon} style={
                    {
                        fontSize: 15,
                        color: 'white',
                        margin: '0 20px 0 10px'
                    }}/>
                {/* <Glyphicon
                    glyph={item.icon}
                    style={{fontSize: 14,
                        color: 'white',
                        margin: '0 20px 0 10px'}} /> */}

                <span style={{
                    color: 'white',
                    fontSize: 14}}>
                    {item.text}
                </span>

            </div>
            </Col>
        );
    }


    // Event Listeners

    onClickChild(pos) {
        this.props.onClickChild(pos);
        this.props.onClickClose();
    }


    onClickSection(func) {
        func();
        this.props.onClickClose();
    }


    onClickAction(func) {
        func();
        this.props.onClickClose();
    }


    // Helper Methods

    formatName(name) {
        if (typeof name !== 'string') return '';

        name = name.toLowerCase().trim();

        let result = '';

        for (let i = 0; i < name.length; i++) {
            const char = name.charAt(i);

            if (i === 0) {
                result = char.toUpperCase();
            }

            else if (name.charAt(i - 1) === ' ' || name.charAt(i - 1) === '.') {
                result += char.toUpperCase();
            }

            else {
                result += char;
            }
        }

        return result;
    }
}



export default NavDrawer